/* KALK · Selector de vista de la colección editorial. */
(() => {
  const ROOT_SELECTOR = '[data-novedades-editorial]';
  const BUTTON_SELECTOR = '[data-novedades-layout-toggle]';

  const normaliseLayout = (value) => (value === 'grid' ? 'grid' : 'editorial');

  function applyLayout(root, requestedLayout) {
    const layout = normaliseLayout(requestedLayout);
    root.dataset.novedadesLayout = layout;

    root.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      const isActive = button.dataset.novedadesLayoutToggle === layout;
      button.setAttribute('aria-pressed', String(isActive));
      button.toggleAttribute('aria-current', isActive);
    });
  }

  function initialise(root) {
    if (!root || root.dataset.novedadesViewSwitcherReady === 'true') return;

    root.dataset.novedadesViewSwitcherReady = 'true';
    applyLayout(root, root.dataset.novedadesLayout);

    root.addEventListener('click', (event) => {
      const button = event.target.closest(BUTTON_SELECTOR);
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      applyLayout(root, button.dataset.novedadesLayoutToggle);
    });
  }

  function initialiseAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) initialise(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
